import React, { useState } from 'react';
import { message, Checkbox, Popconfirm, Popover, Tooltip, Select, Input, Steps, Divider, InputNumber, Form, Alert, Row, Col, Tag, Avatar, Button, Icon, Modal, Calendar } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUserClock, faUserTie, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { faReceipt } from '@fortawesome/free-solid-svg-icons';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import { faFlagCheckered } from '@fortawesome/free-solid-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faInbox } from '@fortawesome/free-solid-svg-icons';
import { colours } from './../utils/colours';
import parse from 'html-react-parser';
import EventTypeIcon from '../components/eventTypeIcon';
import { s3, EVENT_TYPE, EVENT_TYPE_COLOR, editorConfig, getLocationTimeZone } from '../utils';
import CustomAvatar from '../components/customAvatar';
import CreateReminder from '../components/createReminder';
import { format } from 'timeago.js';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { allNations } from './../utils/countries';
import EventBodyDisplay from './../components/eventBodyDisplay';
import { renderBottom } from './../utils/helper';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { getDashboard, setReminderWithEvent, deleteReminder } from '../API';
import { navigate } from "@reach/router"
import Flag from "react-country-flags";
import { buildInvoicePDFTemplate, allCurrencys, getCurrencySign, getCurrencyFullName } from '../utils/invoices';

import moment from 'moment';
import { formItemLayout, formItemLayoutReminderPayment, flexCenterRight } from '../theme';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const { groupBy } = require('lodash');
const { Step } = Steps;
const { Option } = Select;
const momentTZ = require('moment-timezone');

const convertReminderTypeToEventType = (reminderType) => {
  switch (reminderType) {
    case 'contact-candidate':
      return 'phonecall';
    case 'check-payment':
      return 'check-payment';
    case 'send-invoice':
      return 'send-invoice';
    default:
      return null;
  }
}

const renderEventInfo = (item) => {
  return (
    <div style={{ fontWeight: '400', fontSize: '14px' }}>
      {
        item.event.isEmail ?
          <span>
            <Tooltip placement="left" title={`email ${item.event.emailType}`}>
              <FontAwesomeIcon
                style={{ cursor: 'pointer', color: '#B0BF1A' }}
                icon={item.event.emailType === 'sent' ? faPaperPlane : faInbox} />&nbsp;
            </Tooltip>
          </span>
          :
          null
      }
      <EventTypeIcon event={item.event} />
      &nbsp;<Tag color={EVENT_TYPE_COLOR[item.event.type]}>{EVENT_TYPE[item.event.type].text}</Tag>
      operated by
      &nbsp;
      <CustomAvatar
        colourCode={item.event_user.firstname.charAt(0).toLowerCase()}
        char={`${item.event_user.firstname.charAt(0).toUpperCase()}${item.event_user.lastname.charAt(0).toUpperCase()}`}
        charSize={13}
        size={26}
        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${item.event_user.id}.jpeg`}
      />
      &nbsp;
      {item.event_user.firstname} {item.event_user.lastname}
      &nbsp;
      <i style={{ fontSize: '12px', color: '#ccc' }}>
        {format(new Date(moment(item.event.createdAt).format('YYYY-MM-DD HH:mm:ss')))}
      </i>
    </div>
  )
}

function MyCalendarForm({ form, invoiceReminders, reminders }) {
  const { getFieldDecorator } = form;

  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);

  const remindersData = reminders.map((i) => {
    return {
      ...i,
      ...{
        reminderType: 'reminder',
      },
      ...{
        date: moment(i.reminderDate).format('YYYY-MM-DD')
      }
    }
  });

  const data = invoiceReminders.map((i) => {
    return {
      ...i,
      ...{
        reminderType: 'invoice',
      },
      ...{
        date: moment(i.invoice.onBoard, "YYYY-MM-DD")
          .add(i.offset, 'days').format('YYYY-MM-DD')
      }
    }
  });
  const groupedData = groupBy([...data, ...remindersData], 'date');

  const [showReminderModal, setShowReminderModal] = useState(false);
  const [reminderDate, setReminderDate] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [entry, setEntry] = useState(null);

  const [eventBody, setEventBody] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [date, setDate] = useState(moment());

  const [isStepFinish, setIsStepFinish] = useState(false);

  const [needInvoiceWithoutName, setNeedInvoiceWithoutName] = useState(false);

  const [reminderDeleteing, setReminderDeleteing] = useState(false);

  const renderReminderCell = (item, value) => {
    const getReminderIcon = (item) => {
      if (item.isRead) {
        return (
          <Avatar style={{ color: '#fff', backgroundColor: '#8DB600' }} size={19} icon={<FontAwesomeIcon icon={faCheck} />} />
        )
      }
      switch (item.type) {
        case 'contact-candidate':
          return <Avatar size={19} style={{ color: '#fff', backgroundColor: colours[item.candidate.firstname.charAt(0).toLowerCase()] }}>
            <b>{`${item.candidate.firstname.charAt(0).toUpperCase()}${item.candidate.lastname.charAt(0).toUpperCase()}`}</b>
          </Avatar>
        case 'send-invoice':
          return <Avatar style={{ color: '#fff', backgroundColor: '#B284BE' }} size={19} icon={<FontAwesomeIcon icon={faReceipt} />} />;
        case 'check-payment':
          return <Avatar style={{ color: '#fff', backgroundColor: '#FF8C00' }} size={19} icon={<FontAwesomeIcon icon={faPiggyBank} />} />;
        case 'on-board':
          return <FontAwesomeIcon icon={faStar} style={{ fontSize: "16px", color: '#FB607F' }} />;
        case 'finish-rebate':
          return <FontAwesomeIcon icon={faFlagCheckered} style={{ fontSize: "16px", color: '#FB607F' }} />;
        default:
          return null;
      }
    }

    const getReminder = (item) => {
      const name = `${item.candidate.firstname} ${item.candidate.lastname}`;
      let tooltipTitle;
      if (item.offset > 0) {
        tooltipTitle = `Contact ${name} after ${item.offset} days on board`;
      } else {
        tooltipTitle = `Contact ${name} before ${Math.abs(item.offset)} days on board`;
      }

      switch (item.type) {
        case 'contact-candidate':
          return (
            <Tooltip overlayStyle={{ maxWidth: '500px' }} title={tooltipTitle}>
              {getReminderIcon(item)} {item.candidate.firstname} {item.candidate.lastname}
            </Tooltip>
          );
        case 'send-invoice':
          return <span>{getReminderIcon(item)} Send Invoice ({item.client.name})</span>;
        case 'check-payment':
          return <span>{getReminderIcon(item)} Check Bank ({item.client.name})</span>;
        case 'on-board':
          return <span>{getReminderIcon(item)} {item.candidate.firstname} {item.candidate.lastname} on board</span>;
        case 'finish-rebate':
          return <span>{getReminderIcon(item)} {item.candidate.firstname} {item.candidate.lastname} finish rebate</span>;
        default:
          return null;
      }
    }

    if (item.reminderType === 'invoice') {
      return (
        <div style={{ cursor: 'pointer' }} key={item.id} onClick={(e) => {
          e.stopPropagation();
          if (item.type !== 'on-board' && item.type !== 'finish-rebate') {
            setShowModal(true);
            setEntry(item);
          }
        }}>
          {getReminder(item)}
        </div>
      )
    }

    const getStandardReminderIcon = (item, color) => {
      switch (item.type) {
        case 'interview':
          return <FontAwesomeIcon icon={faUserClock} style={{ fontSize: "16px", color: color }} />;
        case 'candidate':
          return <FontAwesomeIcon icon={faUserTie} style={{ fontSize: "16px", color: color }} />;
        case 'contact':
          return <FontAwesomeIcon icon={faUserCircle} style={{ fontSize: "16px", color: color }} />;
        case 'link-global':
          return <FontAwesomeIcon icon={faUser} style={{ fontSize: "16px", color: color }} />;
        default:
          return null;
      }
    }

    const renderGeneralReminderContent = (item) => {
      return (
        <>
          <div style={{ minWidth: '200px', maxWidth: '325px', marginTop: '3px', marginBottom: '15px' }}>
            {
              item.candidate ? (
                <div>
                  <span style={{ cursor: 'pointer' }}
                    onClick={() => {
                      navigate(`/candidates/${item.candidate.id}`);
                    }}
                  >
                    <CustomAvatar
                      colourCode={item.candidate.firstname.charAt(0).toLowerCase()}
                      char={`${item.candidate.firstname.charAt(0).toUpperCase()}${item.candidate.lastname.charAt(0).toUpperCase()}`}
                      charSize={12}
                      src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${item.candidate.id}.jpeg`}
                    />
                    &nbsp;
                    {`${item.candidate.firstname} ${item.candidate.lastname}`}
                  </span>
                </div>
              ) : null
            }
            {
              item.candidate && item.contact ? (
                <div style={{ marginTop: '5px' }} />
              ) : null
            }
            {
              item.contact ? (
                <div>
                  <span style={{ cursor: 'pointer' }}
                    onClick={() => {
                      navigate(`/contacts/${item.contact.id}`);
                    }}
                  >
                    <CustomAvatar
                      colourCode={item.contact.firstname.charAt(0).toLowerCase()}
                      char={`${item.contact.firstname.charAt(0).toUpperCase()}${item.contact.lastname.charAt(0).toUpperCase()}`}
                      charSize={12}
                      src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${item.contact.id}.jpeg`}
                    />
                    &nbsp;
                    {`${item.contact.firstname} ${item.contact.lastname}`}
                  </span>
                  &nbsp;
                  <span>
                    <Button size="small" onClick={() => {
                      navigate(`/clients/${item.client.id}`);
                    }}>{item.client.name}</Button>
                  </span>
                </div>
              ) : null
            }
            {
              item.notes !== null && item.notes !== '' ? (
                <div>
                  <br />
                  {item.notes}
                </div>
              ) : null
            }
          </div>
          {
            item.user.id === session.id ? (
              <div style={flexCenterRight}>
                <Popconfirm
                  placement="left"
                  title="Are you sure to delete this reminder?"
                  onConfirm={async () => {
                    setReminderDeleteing(true);
                    const result = await deleteReminder(session.authToken, { id: item.id });
                    if (result.data.responseCode === 0) {
                      const response = await getDashboard(session.authToken);
                      dispatch({ type: "INIT_DASHBOARD", payload: response.data.data });
                      message.success(result.data.message);
                    }
                    else {
                      message.error(result.data.message);
                    }
                    setReminderDeleteing(false);
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button disabled={reminderDeleteing} type="danger" size="small">
                    {
                      reminderDeleteing ? <Icon type="loading" /> : <Icon type="delete" />
                    }
                    Delete
                  </Button>
                </Popconfirm>
              </div>
            ) : (
              <div style={flexCenterRight}>
                <span style={{ color: '#ccc' }}>created by&nbsp;</span>
                <CustomAvatar
                  showTooltip={true}
                  tooltipTitle={`${item.user.firstname} ${item.user.lastname}`}
                  colourCode={item.user.firstname.charAt(0).toLowerCase()}
                  char={`${item.user.firstname.charAt(0).toUpperCase()}${item.user.lastname.charAt(0).toUpperCase()}`}
                  charSize={12}
                  size={24}
                  src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${item.user.id}.jpeg`}
                />
              </div>
            )
          }
        </>
      )
    }

    const renderContactReminderTitle = (item) => {
      return (
        <div>
          Contact Reminder
        </div>
      )
    }

    const renderCandidateReminderTitle = (item) => {
      return (
        <div>
          Candidate Reminder
        </div>
      )
    }

    const renderInterviewReminderTitle = (item) => {
      const locationTime = momentTZ.tz(item.reminderDate, getLocationTimeZone(item.location));
      return (
        <div>
          <FontAwesomeIcon icon={faClock} /> {item.location}: {locationTime.format('HH:mm')}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <FontAwesomeIcon icon={faClock} /> UK: {moment(item.reminderDate).format('HH:mm')}
        </div>
      )
    }

    const getStandardReminder = (item, value) => {
      switch (item.type) {
        case 'interview':
          return (
            <Popover content={renderGeneralReminderContent(item)} title={renderInterviewReminderTitle(item)}>
              {getStandardReminderIcon(item, '#f759ab')} Interview ({item.candidate.firstname} {item.candidate.lastname}) - {moment(item.reminderDate).format('HH:mm')}/UK
            </Popover>
          )
        case 'candidate':
          return (
            <Popover content={renderGeneralReminderContent(item)} title={renderCandidateReminderTitle(item)}>
              {getStandardReminderIcon(item, '#1E90FF')} Candidate ({item.candidate.firstname} {item.candidate.lastname})
            </Popover>
          )
        case 'contact':
          return (
            <Popover content={renderGeneralReminderContent(item)} title={renderContactReminderTitle(item)}>
              {getStandardReminderIcon(item, '#B284BE')} Contact ({item.contact.firstname} {item.contact.lastname})
            </Popover>
          )
        case 'link-global':
          return (
            <Popover content={renderGeneralReminderContent(item)} title='Link-Global Reminder'>
              {getStandardReminderIcon(item, '#DE5D83')}&nbsp;&nbsp;{item.notes}
            </Popover>
          )
        default:
          return null;
      }
    }

    if (item.reminderType === 'reminder') {
      return (
        <div style={{ cursor: 'pointer' }} key={item.id} onClick={(e) => {
          e.stopPropagation();
        }}>
          {getStandardReminder(item, value)}
        </div>
      )
    }
  }

  function dateCellRender(value) {
    const listData = groupedData[moment(value).format('YYYY-MM-DD')] || [];
    return (
      <div>
        {listData.map(item => (
          renderReminderCell(item, value)
        ))}
      </div>
    );
  }

  const disabledDate = (currentDate) => {
    if (moment().add(-1, 'day') >= currentDate) {
      return currentDate
    }
  };

  const renderModalTitleRight = (item) => {

    const getTypeName = (type) => {
      switch (type) {
        case 'contact-candidate':
          return "Contact Candidate";
        case 'send-invoice':
          return "Send Invoice";
        case 'check-payment':
          return "Check Bank Payment";
        default:
          return null;
      }
    }

    const getWords = (offset) => {
      if (offset > 0) {
        return 'after'
      } else {
        return 'before'
      }
    }

    return (
      <div style={{ fontSize: '14px', fontWeight: '400' }}>
        <Tag color="geekblue">{getTypeName(item.type)}</Tag>
        {getWords(item.offset)}
        &nbsp;
        <Tag color="#2db7f5">{Math.abs(item.offset)}</Tag>
        days on board at {moment(item.invoice.onBoard).format('YYYY-MM-DD')}
      </div>
    )
  }

  const renderModalTitle = (item) => {
    if (item) {
      return (
        <Row>
          <Col span={12}>
            <Avatar size={24} style={{ color: '#fff', backgroundColor: colours[item.contact.firstname.charAt(0).toLowerCase()] }}>
              <b>{`${item.contact.firstname.charAt(0).toUpperCase()}${item.contact.lastname.charAt(0).toUpperCase()}`}</b>
            </Avatar>
            &nbsp;{item.contact.firstname} {item.contact.lastname}
            {
              item.additionalEvent ? (
                <>
                  &nbsp;
                  <Avatar size={24} style={{ color: '#fff', backgroundColor: colours[item.additionalContact.firstname.charAt(0).toLowerCase()] }}>
                    <b>{`${item.additionalContact.firstname.charAt(0).toUpperCase()}${item.additionalContact.lastname.charAt(0).toUpperCase()}`}</b>
                  </Avatar>
                  &nbsp;{item.additionalContact.firstname} {item.additionalContact.lastname}
                </>
              ) : null
            }
            &nbsp;<Tag>{item.client.name}</Tag>
            &nbsp;&nbsp;&nbsp;
            <Avatar size={24} style={{ color: '#fff', backgroundColor: colours[item.candidate.firstname.charAt(0).toLowerCase()] }}>
              <b>{`${item.candidate.firstname.charAt(0).toUpperCase()}${item.candidate.lastname.charAt(0).toUpperCase()}`}</b>
            </Avatar>
            &nbsp;{item.candidate.firstname} {item.candidate.lastname}
          </Col>
          <Col span={12} style={flexCenterRight}>
            {
              entry && entry.event ? (
                renderEventInfo(entry)
              ) : null
            }
            {
              entry && !entry.event ? (
                renderModalTitleRight(entry)
              ) : null
            }
          </Col>
        </Row>
      )
    }
  }

  const renderReminderContent = (item) => {
    if (item) {
      // const reminderTime = moment(item.invoice.onBoard, "YYYY-MM-DD HH:mm:ss").add(item.offset, 'days');

      // if (moment() < reminderTime) {
      //   return (
      //     <Alert
      //       message="No need to take action at moment"
      //       type="info"
      //       showIcon
      //     />
      //   )
      // }

      switch (item.type) {
        case 'contact-candidate':
          return renderCandidateEvent(item);
        case 'check-payment':
          return renderPaymentEvent(item);
        case 'send-invoice':
          return <RenderInvoiceEvent item={item} />;
        default:
          return null;
      }
    }
  }

  function RenderInvoiceEventForm({ form, item }) {

    const buildEmailBody = (item) => {
      let p1 = `<p>Please find attached <b>invoice-${item.invoice.reference}</b> for the recent recruitment of ${item.candidate.firstname} ${item.candidate.lastname}</p>`;
      let p2 = '<p>Could you please confirm receipt of this invoice and notify me straight away should you have any queries with the fee or issues with the invoice name and / or address.';
      const p3 = '<p>Otherwise, it would be greatly appreciated if you would pass it to your finance department for payment.</p>';
      const p4 = `<p>Please be advised our standard payment terms are ${item.invoice.paymentTerm} days from invoice date.</p>`;
      const p5 = '<p>Kind Regards</p>';

      if (needInvoiceWithoutName) {
        p1 = `<p>Please find attached <b>invoice-${item.invoice.reference}</b> and <b>invoice-${item.invoice.reference} without name</b> for the recent recruitment of ${item.candidate.firstname} ${item.candidate.lastname}</p>`;
        p2 = '<p>Could you please confirm receipt of these invoices and notify me straight away should you have any queries with the fee or issues with the invoices name and / or address.';
      }
      return p1 + p2 + p3 + p4 + p5;
    }

    const { getFieldDecorator } = form;

    const [pdfURL, setPdfURL] = useState(null);
    const [emailBody, setEmailBody] = useState(buildEmailBody(item));

    const [current, setCurrent] = useState(0);
    const [sendEmailLoading, setSendEmailLoading] = useState(false);

    const [data, setData] = useState({
      contactName: `${item.contact.firstname} ${item.contact.lastname}`,
      contactEmail: item.contact.email,
      cc: item.invoice.ccString !== '' ? item.invoice.ccString : undefined,
      additionalContactName: item.additionalContact ? `${item.additionalContact.firstname} ${item.additionalContact.lastname}` : undefined,
      additionalContactEmail: item.additionalContact ? item.additionalContact.email : undefined,
      fee: item.invoice.fee,
      currency: item.invoice.currency,
      name: item.client.invoiceClientName,
      add1: item.client.invoiceAddress.address1,
      add2: item.client.invoiceAddress.address2,
      city: item.client.invoiceAddress.city,
      country: item.client.invoiceAddress.country,
      postcode: item.client.invoiceAddress.postcode,
    })

    if (item.isRead) {
      return (
        <div>
          {item.event.body === "" ?
            <span style={{ color: '#ddd' }}>Empty body</span>
            :
            <>
              <EventBodyDisplay data={item.event.body} />
              {renderBottom(item.event)}
            </>
          }
        </div>
      )
    }

    if (
      item.client.invoiceClientName &&
      item.client.invoiceClientName !== '' &&
      item.client.invoiceAddress &&
      item.client.invoiceAddress.address1 &&
      item.client.invoiceAddress.address1 !== '' &&
      item.client.invoiceAddress.address2 &&
      item.client.invoiceAddress.address2 !== '' &&
      item.client.invoiceAddress.country &&
      item.client.invoiceAddress.country !== ''
      // item.client.invoiceAddress.postcode &&
      // item.client.invoiceAddress.postcode !== ''
    ) {

      const next = async () => {
        if (current === 0) {
          // save step 1 data, no longer use
          const formResult = await form.validateFields();
          setData({
            contactName: formResult.invoiceContactName,
            additionalContactName: formResult.invoiceAdditionalContactName,
            contactEmail: formResult.invoiceContactEmail,
            additionalContactEmail: formResult.invoiceAdditionalContactEmail,
            cc: formResult.cc,
            fee: formResult.invoiceFee,
            currency: formResult.invoiceCurrency,
            name: formResult.invoiceClientName,
            add1: formResult.invoiceAddress1,
            add2: formResult.invoiceAddress2,
            city: formResult.invoiceCity,
            country: formResult.invoiceCountry,
            postcode: formResult.invoicePostcode,
          });

          // prepare invoice pdf
          const template = await buildInvoicePDFTemplate(item, true, false);

          pdfMake.createPdf(template).getBuffer((buffer) => {
            const dataUrl = URL.createObjectURL(new Blob([buffer], {
              type: "application/pdf"
            }));
            setPdfURL(dataUrl);
          });
        }

        setCurrent(current + 1);
      };

      const prev = () => {
        setCurrent(current - 1);
      };

      const renderPreviewEmail = () => {
        return (
          <div style={{ marginTop: '15px' }}>
            <CKEditor
              value={emailBody}
              data={emailBody}
              editor={Editor}
              config={editorConfig}
              onChange={(event, editor) => {
                const data = editor.getData();
                setEmailBody(data);
              }}
            />
          </div>
        )
      }

      const renderInvoicePDF = () => {
        return (
          <div style={{ marginTop: '15px', marginBottom: '5px' }}>
            {
              pdfURL !== null ? (
                <iframe
                  title="invoice"
                  src={pdfURL}
                  style={{ width: '100%', height: '355px', border: 0 }}
                />
              ) : null
            }
          </div>
        )
      }

      const renderInvoiceAddressForm = () => {
        const nations = allNations();

        const countrySelection = [];
        for (let i = 0; i < nations.length; i++) {
          countrySelection.push(
            <Option key={i} value={nations[i].name} label={nations[i].name}>
              <Row>
                <Col span={4}>
                  <Flag country={nations[i].code} asSquare={true} style={{ width: '30px', height: '20px' }} />
                </Col>
                <Col>
                  {nations[i].name}
                </Col>
              </Row>
            </Option>
          )
        }

        return (
          <div>
            <br />
            <Row>
              <Col span={12}>
                <div style={{ marginRight: '10px' }}>
                  <Form.Item {...formItemLayout} label="Contact Name">
                    {getFieldDecorator('invoiceContactName', {
                      initialValue: data.contactName,
                      rules: [{ required: true, message: 'Please input contact name!' }],
                    })(
                      <Input disabled autoComplete="off" placeholder="Contact Name" />
                    )}
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div style={{ marginLeft: '10px' }}>
                  <Form.Item {...formItemLayout} label="Contact Email">
                    {getFieldDecorator('invoiceContactEmail', {
                      initialValue: data.contactEmail,
                      rules: [{ required: true, message: 'Please input contact email!' }],
                    })(
                      <Input disabled autoComplete="off" placeholder="Contact Email" />
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {
              data.additionalContactName && data.additionalContactEmail ? (
                <Row>
                  <Col span={12}>
                    <div style={{ marginRight: '10px' }}>
                      <Form.Item {...formItemLayout} label="Other Contact Name">
                        {getFieldDecorator('invoiceAdditionalContactName', {
                          initialValue: data.additionalContactName,
                        })(
                          <Input disabled autoComplete="off" placeholder="Other Contact Name" />
                        )}
                      </Form.Item>
                    </div>
                  </Col>

                  <Col span={12}>
                    <div style={{ marginLeft: '10px' }}>
                      <Form.Item {...formItemLayout} label="Other Contact Email">
                        {getFieldDecorator('invoiceAdditionalContactEmail', {
                          initialValue: data.additionalContactEmail,
                        })(
                          <Input disabled autoComplete="off" placeholder="Other Contact Email" />
                        )}
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              ) : null
            }

            {
              data.cc ? (
                <Row>
                  <div>
                    <Form.Item {...{
                      labelCol: { span: 3 },
                      wrapperCol: { span: 21 },
                    }}  label="CC With Contact">
                      {getFieldDecorator('cc', {
                        initialValue: data.cc,
                      })(
                        <Input disabled autoComplete="off" placeholder="CC with Contact" />
                      )}
                    </Form.Item>
                  </div>
                </Row>
              ) : null
            }
            <Row>
              
            </Row>

            <Row>
              <Col span={12}>
                <Row>
                  <Col span={12}>
                    <Form.Item {...{
                      labelCol: { span: 12 },
                      wrapperCol: { span: 12 },
                    }} label="Fee">
                      {getFieldDecorator('invoiceFee', {
                        initialValue: data.fee,
                        rules: [{ required: true, message: 'Please input fee!' }],
                      })(
                        <InputNumber
                          disabled
                          placeholder="Input fee"
                          style={{ width: '100%' }}
                          min={1} max={1000000} />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <div style={{ marginRight: '10px' }}>
                      <Form.Item {...{
                        labelCol: { span: 10 },
                        wrapperCol: { span: 14 },
                      }} label="Currency">
                        {getFieldDecorator('invoiceCurrency', {
                          initialValue: data.currency,
                          rules: [{ required: true, message: 'Please select currency!' }],
                        })(
                          <Select
                            disabled
                            showSearch={true}
                            placeholder="Select currency"
                            style={{ width: '100%' }}
                          >
                            {
                              allCurrencys.map((i) => (
                                <Option key={i} value={i}>
                                  {i}
                                </Option>
                              ))
                            }
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col span={12}>
                <div style={{ marginLeft: '10px' }}>
                  <Form.Item {...formItemLayout} label="Client Name">
                    {getFieldDecorator('invoiceClientName', {
                      initialValue: data.name,
                      rules: [{ required: true, message: 'Please input client name!' }],
                    })(
                      <Input disabled autoComplete="off" placeholder="Client Name" />
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <div style={{ marginRight: '10px' }}>
                  <Form.Item {...formItemLayout} label="Address 1">
                    {getFieldDecorator('invoiceAddress1', {
                      initialValue: data.add1,
                      rules: [{ required: true, message: 'Please input address1!' }],
                    })(
                      <Input disabled autoComplete="off" placeholder="Address 1" />
                    )}
                  </Form.Item>

                  <Form.Item {...formItemLayout} label="City">
                    {getFieldDecorator('invoiceCity', {
                      initialValue: data.city,
                    })(
                      <Input disabled autoComplete="off" placeholder="City" />
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ marginLeft: '10px' }}>
                  <Form.Item {...formItemLayout} label="Address 2">
                    {getFieldDecorator('invoiceAddress2', {
                      initialValue: data.add2,
                      rules: [{ required: true, message: 'Please input address2!' }],
                    })(
                      <Input disabled autoComplete="off" placeholder="Address 2" />
                    )}
                  </Form.Item>

                  <Row>
                    <Col span={14}>
                      <div style={{ marginLeft: '5px' }}>
                        <Form.Item {...{
                          labelCol: { span: 10 },
                          wrapperCol: { span: 14 },
                        }} label="Country">
                          {getFieldDecorator('invoiceCountry', {
                            initialValue: data.country,
                            rules: [{ required: true, message: 'Please select country!' }],
                          })(
                            <Select
                              disabled
                              style={{ width: '100%' }}
                              placeholder="Country"
                              optionLabelProp="label"
                              showSearch
                            >
                              {countrySelection}
                            </Select>
                          )}
                        </Form.Item>
                      </div>
                    </Col>

                    <Col span={10}>
                      <Form.Item {...{
                        labelCol: { span: 12 },
                        wrapperCol: { span: 12 },
                      }} label="Post Code">
                        {getFieldDecorator('invoicePostcode', {
                          initialValue: data.postcode,
                        })(
                          <Input disabled autoComplete="off" placeholder="Post Code" />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={12} />
              <Col span={12}>
                <div style={{ marginLeft: '10px' }}>
                  <Form.Item {...formItemLayout} label="Need Invoice Without Name">
                    {getFieldDecorator('need-invoice-without-name', {
                    })(
                      <Checkbox checked={needInvoiceWithoutName}
                        onChange={() => {
                        setNeedInvoiceWithoutName(!needInvoiceWithoutName);
                      }}/>
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </div>
        )
      }

      const steps = [
        {
          title: 'Check Contact, Fee and Invoice Address',
          content: renderInvoiceAddressForm(),
        },
        {
          title: 'Preview Invoice PDF',
          content: renderInvoicePDF(),
        },
        {
          title: 'Preview Email',
          content: renderPreviewEmail(),
        },
      ];

      return (
        <div>
          <Steps current={current}>
            {steps.map(item => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div style={{ height: '435px' }} className="steps-content">{steps[current].content}</div>
          <div className="steps-action" style={flexCenterRight}>
            {current > 0 && (
              <Button
                disabled={sendEmailLoading}
                style={{ margin: '0 8px' }} onClick={() => prev()}>
                <Icon type="arrow-left" /> Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <div>
                {
                  current === 0 ? (
                    <>
                     &nbsp;&nbsp;
                    </>
                  ) : null
                }
                <Button
                  disabled={sendEmailLoading}
                  type="primary" onClick={() => next()}>
                  Next <Icon type="arrow-right" />
                </Button>
              </div>
            )}
            {current === steps.length - 1 && (
              <Button
                disabled={sendEmailLoading}
                type="primary" onClick={async () => {
                  const template = await buildInvoicePDFTemplate(item, true, false);
                  const templateWithoutName = await buildInvoicePDFTemplate(item, true, true);
                  pdfMake.createPdf(template).getBase64(async (base64data) => {
                    pdfMake.createPdf(templateWithoutName).getBase64(async (base64dataWithoutName) => {

                      setSendEmailLoading(true);

                      let params = {
                        id: entry.id,
                        invoiceId: entry.invoice.id,
                        reminderType: entry.type,
                        type: convertReminderTypeToEventType(entry.type),
                        contact: entry.contact.id,
                        candidate: entry.candidate.id,
                        emailSubject: `Invoice for Candidate ${entry.candidate.firstname} ${entry.candidate.lastname}`,
                        emailBody: emailBody,
                        invoiceFile: [{
                          name: `Invoice-${entry.invoice.reference}.pdf`,
                          type: 'application/pdf',
                          data: base64data,
                        }]
                      }
  
                      if (entry.additionalContact) {
                        params = {
                          ...params,
                          ...{
                            additionalContact: entry.additionalContact.id,
                          }
                        }
                      }

                      if (entry.invoice.ccString && entry.invoice.ccString !== '') {
                        params = {
                          ...params,
                          ...{
                            cc: entry.invoice.ccString,
                          }
                        }
                      }

                      if (needInvoiceWithoutName) {
                        const file = {
                          name: `Invoice-${entry.invoice.reference} without name.pdf`,
                          type: 'application/pdf',
                          data: base64dataWithoutName,
                        };
                        params = {
                          ...params,
                          ...{
                            invoiceFile: [...params.invoiceFile, ...[file]],
                          }
                        }
                      }
  
                      const result = await setReminderWithEvent(
                        session.authToken,
                        params,
                      );
  
                      if (result.data.responseCode === 0) {
                        const response = await getDashboard(session.authToken);
                        dispatch({ type: "INIT_DASHBOARD", payload: response.data.data });
  
                        setSendEmailLoading(false);
                        setShowModal(false);
                        setEntry(null);
                        setNeedInvoiceWithoutName(false);
                        setEmailBody(null);
  
                        message.success(result.data.message);
                      }
                      else {
                        setSendEmailLoading(false);
                        message.error(result.data.message.toString());
                      }
                    })
                  });
                }}>
                {sendEmailLoading ? <Icon type="loading" /> : <Icon type="check" />} Send Invoice
              </Button>
            )}
          </div>
        </div>
      )
    }
    return (
      <Alert
        message={
          <>
            Please complete client invoice address first.
            &nbsp;
            <span onClick={() => {
              navigate(`/clients/${item.client.id}`)
            }}>
              Go to <Tag style={{ cursor: 'pointer' }} >{item.client.name}</Tag>
            </span>
          </>
        }
        type="warning"
        showIcon
      />
    )
  }

  const RenderInvoiceEvent = Form.create({ name: 'sent-invoice-event-form' })(RenderInvoiceEventForm);

  const renderPaymentEvent = (item) => {
    if (item.isRead) {
      return (
        <div>
          <div>
            Actual Fee Received in {getCurrencyFullName(item.invoice.actualCurrency)}: <Tag color='#f5222d'>{getCurrencySign(item.invoice.actualCurrency)}{item.invoice.actualFee.toLocaleString()}</Tag>
          </div>
          <br />
          {
            item.event.body === '' ? (
              <span style={{ color: '#ddd' }}>Empty body</span>
            ) : (
              <>
                {parse(item.event.body)}
              </>
            )
          }
        </div>
      )
    }

    return (
      <div>
        <Row>
          <Col span={8}>
            <Form.Item {...formItemLayoutReminderPayment} label="Actual Currency">
              {getFieldDecorator('actualCurrency', {
                rules: [{ required: true, message: 'Please select actual currency!' }],
              })(
                <Select
                  disabled={submitting}
                  showSearch={true}
                  placeholder="Select actual currency"
                  style={{ width: '100%' }}
                >
                  {
                    allCurrencys.map((i) => (
                      <Option key={i} value={i}>
                        {i}
                      </Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...formItemLayoutReminderPayment} label="Actual Fee">
              {getFieldDecorator('actualFee', {
                rules: [{ required: true, message: 'Please input actual fee!' }],
              })(
                <InputNumber
                  disabled={submitting}
                  placeholder="Input actual fee"
                  style={{ width: '100%' }}
                  min={1} max={1000000} />
              )}
            </Form.Item>
          </Col>
        </Row>
        <CKEditor
          value={eventBody}
          data={eventBody}
          editor={Editor}
          config={editorConfig}
          onChange={(event, editor) => {
            const data = editor.getData();
            setEventBody(data);
          }}
        />
      </div>
    )
  }

  const renderCandidateEvent = (item) => {
    if (item.isRead) {
      return (
        <div>
          {
            item.event.body === '' ? (
              <span style={{ color: '#ddd' }}>Empty body</span>
            ) : (
              <>
                {parse(item.event.body)}
              </>
            )
          }
        </div>
      )
    }

    return (
      <div>
        <CKEditor
          value={eventBody}
          data={eventBody}
          editor={Editor}
          config={editorConfig}
          onChange={(event, editor) => {
            const data = editor.getData();
            setEventBody(data);
          }}
        />
      </div>
    )
  }

  const footerButtons = [
    <Button
      disabled={submitting}
      key="cancel" onClick={() => {
        setShowModal(false);
        setEntry(null);
        setNeedInvoiceWithoutName(false);
        setEventBody(null);
        setIsStepFinish(false);
      }}>
      <Icon type="close" />
      Close
    </Button>,
    <Button
      disabled={submitting}
      type="primary" key="submit" onClick={async () => {
        const formResult = await form.validateFields();

        setSubmitting(true);

        let params = {
          id: entry.id,
          reminderType: entry.type,
          type: convertReminderTypeToEventType(entry.type),
          contact: entry.contact.id,
          candidate: entry.candidate.id,
        }

        if (entry.type === 'contact-candidate') {
          params = {
            ...params,
            ...{
              body: eventBody,
            }
          }
        }

        if (entry.type === 'check-payment') {
          params = {
            ...params,
            ...{
              invoiceId: entry.invoice.id,
              actualFee: formResult.actualFee,
              actualCurrency: formResult.actualCurrency,
              body: eventBody,
            }
          }
        }

        if (entry.type === 'contact-candidate' || entry.type === 'check-payment') {
          const result = await setReminderWithEvent(
            session.authToken,
            params,
          );

          if (result.data.responseCode === 0) {
            const response = await getDashboard(session.authToken);
            dispatch({ type: "INIT_DASHBOARD", payload: response.data.data });

            setShowModal(false);
            setEntry(null);
            setEventBody(null);
            setSubmitting(false);

            message.success(result.data.message);
          }
          else {
            setSubmitting(false);
            message.error(result.data.message.toString());
          }
          // end of handle of contact-candidate, check-payment
        }
      }}>
      {
        submitting ? <Icon type="loading" /> : <Icon type="check" />
      }
      Submit
    </Button>,
  ];

  const controlButton = () => {
    if (
      (entry && moment() < moment(entry.invoice.onBoard, "YYYY-MM-DD HH:mm:ss").add(entry.offset, 'days')) ||
      (!isStepFinish && entry && entry.type === 'send-invoice')
    ) {
      return [footerButtons[0]]
    } else {
      if (entry && !entry.isRead) {
        return footerButtons;
      }
      return [footerButtons[0]]
    }
  }

  return (
    <>
      <Modal
        centered={true}
        title={renderModalTitle(entry)}
        closable={false}
        visible={showModal}
        width="90%"
        footer={controlButton()}
      >
        <div>
          {renderReminderContent(entry)}
        </div>
      </Modal>
      {
        showReminderModal ? (
          <CreateReminder
            showReminderModal={showReminderModal}
            reminderDate={reminderDate}
            handleOnClose={() => {
              setShowReminderModal(false);
              setReminderDate(null);
            }}
          />
        ) : null
      }
      <Calendar
        onSelect={(date) => {
          setShowReminderModal(true);
          setReminderDate(date);
        }}
        disabledDate={disabledDate}
        dateCellRender={dateCellRender}
        value={date}
        headerRender={() => (
          <div>
            <Row>
              <Col span={12}>
                <span>Year: <span style={{ fontSize: '16px', fontWeight: '600' }}>{moment(date).format('YYYY')}</span></span>
                &nbsp;&nbsp;
                <span>Month: <span style={{ fontSize: '16px', fontWeight: '600' }}>{moment(date).format('MMMM')}</span></span>
              </Col>
              <Col span={12} style={flexCenterRight}>
                <div>
                  <Button type="primary" size="small" onClick={() => setDate(moment(moment(date).format('YYYY-MM-DD')).add(-1, 'months'))}>
                    <Icon type="arrow-left" />Previous Month
                  </Button>
                  &nbsp;&nbsp;
                  <Button type="primary" size="small" onClick={() => setDate(moment(moment().format('YYYY-MM-DD')))}>
                    Today
                  </Button>
                  &nbsp;&nbsp;
                  <Button type="primary" size="small" onClick={() => setDate(moment(moment(date).format('YYYY-MM-DD')).add(1, 'months'))}>
                    Next Month<Icon type="arrow-right" />
                  </Button>
                </div>
              </Col>
            </Row>
            <Divider />
          </div>
        )}
      />
    </>
  );
}

const MyCalendar = Form.create({ name: 'invoices' })(MyCalendarForm);

export default MyCalendar;
